import { Box, Typography } from "@bca/ui-library";
import React from "react";
import { formatMoney } from "../formatMoney";
import { InvoiceBreakdown } from "../Interfaces/vehicle.type";

interface InvoiceListItemsProps {
  invoiceData: InvoiceBreakdown;
}

const InvoiceListItems: React.FunctionComponent<InvoiceListItemsProps> = ({
  invoiceData = { lineItems: [] },
}) => {
  return (
    <Box
      flexDirection="column"
      marginY={{
        mobile: "32px",
        desktop: "16px",
      }}
    >
      {invoiceData?.lineItems?.map((el, index) => (
        <Box key={index} display="flex" justifyContent="space-between">
          <Typography
            color="grey-blue"
            css="opacity: 0.8;"
            variant="body-small"
          >
            {el?.name}
          </Typography>
          <Typography color="footer-blue" variant="body-small">
            {formatMoney(parseFloat(el.netAmount), 2)}
          </Typography>
        </Box>
      ))}
      <Box display="flex" justifyContent="space-between">
        <Typography color="grey-blue" css="opacity: 0.8;" variant="body-small">
          VAT
        </Typography>
        <Typography color="footer-blue" variant="body-small">
          {formatMoney(invoiceData.vatAmount, 2)}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between">
        <Typography color="grey-blue" css="opacity: 0.8;" variant="body-small">
          Total
        </Typography>
        <Typography color="footer-blue" variant="body-small">
          {formatMoney(invoiceData.grossAmount, 2)}
        </Typography>
      </Box>
    </Box>
  );
};

export default InvoiceListItems;
